import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  connect() {
    const successFlash = document.querySelector('.flash-success');

    // Always attach bill modal close button logic
    const billCloseBtn = document.getElementById('closeBillModal');
    const billModalElement = document.getElementById('billModal');
    let billModal;
    if (billCloseBtn && billModalElement) {
      billModal = new bootstrap.Modal(billModalElement);
      billCloseBtn.addEventListener('click', () => {
        billModal.hide();
      });
    }

    // Prevent re-showing modals on back
    if (!successFlash || successFlash.dataset.handled === "true") return;

    successFlash.dataset.handled = "true";

    const confirmModalElement = document.getElementById('confirmModal');
    const confirmModal = new bootstrap.Modal(confirmModalElement);
    confirmModal.show();

    const closeBtns = [
      document.getElementById('closeConfirmModal'),
      document.getElementById('closeConfirmModalFooter')
    ];

    closeBtns.forEach(btn => {
      if (btn) {
        btn.addEventListener('click', () => {
          confirmModal.hide();
        });
      }
    });

    const yesBtn = document.getElementById('yesContinue');
    if (yesBtn) {
      yesBtn.addEventListener('click', () => {
        confirmModal.hide();
        if (billModalElement) {
          const newBillModal = new bootstrap.Modal(billModalElement);
          newBillModal.show();
        }
      });
    }
  }
}
